import useSWR, { KeyedMutator } from 'swr';
import { StrapiCMSFetcher } from './cms-fetcher';

type StrapiBlogPost = {
  id: number;
  attributes: {
    title: string;
    // Markdown:
    body: string;
    glossaryTags: string[];
  };
};

export default function useGlossaryEntry(entryId: number, token: string) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: { data: StrapiBlogPost };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    entryId ? `glossaries/${entryId}` : null,
    StrapiCMSFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data: data?.data,
    error,
    mutate,
  };
}
